import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function PaymentReceipt() {
  const { ref } = useParams();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/payments/receipts/by-ref/${encodeURIComponent(ref)}`)
      .then(r => setReceipt(r.data))
      .catch(() => setError(true));
  }, [ref]);

  const fmtDate = (d) => {
    if (!d) return '—';
    const date = new Date(d);
    return date.toLocaleString('en-ZA', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const amount = receipt ? 'R' + Number(receipt.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 16px' }}>
      <div style={{ width: '100%', maxWidth: '440px' }}>
        {error ? (
          <div style={{ textAlign: 'center', padding: '48px 20px', background: 'var(--white)', borderRadius: 16, boxShadow: 'var(--shadow-lg)' }}>
            <div style={{ fontSize: 40 }}>📄</div>
            <h3 style={{ margin: '12px 0 6px' }}>Receipt not found</h3>
            <p style={{ color: 'var(--gray)', fontSize: 14 }}>We couldn't find a receipt for this payment. It may still be processing.</p>
            <button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/dashboard')}>Back to Dashboard</button>
          </div>
        ) : !receipt ? (
          <div style={{ textAlign: 'center', padding: '48px 20px', background: 'var(--white)', borderRadius: 16, boxShadow: 'var(--shadow-lg)' }}>
            <div className="skeleton-text" style={{ width: '70%', margin: '0 auto 12px' }} />
            <div className="skeleton-text" style={{ width: '50%', margin: '0 auto' }} />
          </div>
        ) : (
          <div style={{ background: 'var(--white)', borderRadius: 20, overflow: 'hidden', boxShadow: 'var(--shadow-xl)' }}>
            {/* Header */}
            <div style={{ background: 'linear-gradient(135deg, #E3425C, #b92c45)', color: '#fff', padding: '28px 24px', textAlign: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                <img src="/favicon-192x192.png" alt="GGR" style={{ width: 52, height: 52, borderRadius: 14, background: '#fff', padding: 6 }} />
              </div>
              <h2 style={{ margin: 0, fontSize: 20, color: '#fff' }}>Grand Gather Registry</h2>
              <p style={{ margin: '4px 0 0', fontSize: 12, opacity: 0.85 }}>Seamless Events · Thoughtful Gifting</p>
            </div>

            {/* Body */}
            <div style={{ padding: '28px 24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <div>
                  <div style={{ fontSize: 11, color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: 1 }}>Payment Receipt</div>
                  <div style={{ fontSize: 15, fontWeight: 700 }}>{receipt.receipt_number}</div>
                </div>
                <div style={{ background: '#10b981', color: '#fff', fontSize: 12, fontWeight: 700, padding: '6px 14px', borderRadius: 20 }}>PAID</div>
              </div>

              <div style={{ textAlign: 'center', padding: '18px 0 22px', borderBottom: '1px dashed var(--cream-dark)' }}>
                <div style={{ fontSize: 13, color: 'var(--gray)' }}>Amount paid</div>
                <div style={{ fontSize: 38, fontWeight: 800, color: 'var(--rose-deep)' }}>{amount}</div>
                <div style={{ fontSize: 13, color: 'var(--gray)', marginTop: 4 }}>{receipt.event_title || 'Payment'}{receipt.vendor_name ? ` · ${receipt.vendor_name}` : ''}</div>
              </div>

              <div style={{ paddingTop: 18, fontSize: 14 }}>
                {[
                  ['Date paid', fmtDate(receipt.paid_at)],
                  ['Payment method', (receipt.gateway || 'Ozow').toUpperCase()],
                  ['Reference', receipt.gateway_reference || '—'],
                  ['Status', 'Confirmed'],
                  ['Payer', receipt.payer_name || '—'],
                ].map(([k, v]) => (
                  <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--cream-dark)' }}>
                    <span style={{ color: 'var(--gray)' }}>{k}</span>
                    <span style={{ fontWeight: 600, textAlign: 'right' }}>{v}</span>
                  </div>
                ))}
              </div>

              <p style={{ fontSize: 12, color: 'var(--gray)', marginTop: 18, lineHeight: 1.6 }}>
                This receipt confirms your payment was received by Grand Gather Registry (Pty) Ltd via Ozow. Thank you for trusting us with your event.
              </p>

              <button className="btn btn-primary btn-full" style={{ marginTop: 20 }} onClick={() => navigate(-1)}>Done</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
